module.exports = "/static/media/popUpCartoonBg.d1ea949e.jpg";